import useTranslation from "@/hooks/useTranslation";
import MetricWidget from "../../components/MetricWidget/MetricWidget";
import { useMaterialImpactTotals } from "../../hooks/useMaterialImpact";
import { ImpactMetric } from "../../utils/types";

export default function MaterialImpactTotal({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = useMaterialImpactTotals({ metrics: [metric.key] });
  const translation = useTranslation();

  return (
    <MetricWidget
      title={"Material footprint"}
      tooltip={translation["dashboard"]["material"]["total"]}
      loading={isLoading || isFetching}
      format={metric.formatter}
      metric={metric}
      data={{
        value: data?.material_impact[metric.key],
        comparison: {
          label: "of company total",
          value: data?.company_impact[metric.key],
        },
      }}
    />
  );
}
